import { zoom, zoomIdentity } from 'd3-zoom'
import { drag } from 'd3-drag'
import { select } from 'd3-selection'
import { json } from 'd3-fetch'
import { tick } from './tick'
import { update } from './update'
import { simulation } from './simulation'
import { subject, dragStart, dragging, dragEnd, zoomStart, zooming, zoomEnd, zoomFilter, zoomWheelDelta } from './interaction'
import { pixelRatio, container, visibleCanvas, hiddenCanvas, noVisibleCanvas, scaleExtent } from './utils'
import * as storage from './storage'
import * as branding from './branding'
import './handlers'

const setup = (): void => {
  if (noVisibleCanvas()) return
  if (pixelRatio() > 1) {
    visibleCanvas().getContext('2d').scale(pixelRatio(), pixelRatio())
    hiddenCanvas().getContext('2d').scale(pixelRatio(), pixelRatio())
  }

  globalThis._TRANSFORM_ = zoomIdentity
  globalThis._IMAGES_ = {}
  globalThis._NEIGHBOR_PILL_TEXTS_ = {}
  globalThis._STORAGE_ = { nodes: [], links: [], nodeIds: [], linkIds: [] }
  globalThis._CONTAINER_ = select(document.createElement('custom'))

  json(container().dataset.configurationUrl).then(async function (configuration) {
    globalThis._CONFIGURATION_ = configuration

    json(configuration.imagesUrl).then(async function (images) {
      storage.images(images)
    }).catch((error) => console.error(error))

    json(configuration.pillTextsUrl).then(async function (pillTexts) {
      storage.pillTexts(pillTexts)
    }).then(() => {
      globalThis._NEIGHBOR_PILL_IDS_ = Object.keys(globalThis._NEIGHBOR_PILL_TEXTS_)
    }).catch((error) => console.error(error))

    branding.image()

    select(visibleCanvas())
      .call(drag().subject(subject).on('start', dragStart).on('drag', dragging).on('end', dragEnd))
      .call(zoom().scaleExtent(scaleExtent()).on('start', zoomStart).on('zoom', zooming).on('end', zoomEnd).filter(zoomFilter).wheelDelta(zoomWheelDelta))
  }).then(function () {
    resize()
    draw()
  }).catch((error) => {
    console.error(error)
  })
}

const resize = (): void => {
  if (noVisibleCanvas()) return
  const width: number = window.innerWidth // container().offsetWith
  const height: number = window.innerHeight

  globalThis._CONFIGURATION_.width = width
  globalThis._CONFIGURATION_.height = height
  globalThis._CONFIGURATION_.pixelRatioWidth = width * pixelRatio()
  globalThis._CONFIGURATION_.pixelRatioHeight = height * pixelRatio()

  select(visibleCanvas())
    .attr('width', width * pixelRatio())
    .attr('height', height * pixelRatio())
    .attr('style', `width: ${width}px; height: ${height}px;`)

  select(hiddenCanvas())
    .attr('width', width * pixelRatio())
    .attr('height', height * pixelRatio())
    .attr('style', 'display: none;')

  if (globalThis._SIMULATION_ !== undefined) tick()
}

const draw = (url: string = container().dataset.url): void => {
  json(url).then(async function (data) {
    storage.patch(data.nodes, data.links)
  }).then(() => update())
    .then(() => simulation())
    .catch((error) => console.error(error))
}

// Initializing
document.addEventListener('DOMContentLoaded', function () {
  setup()
})

// Resizing
if (window.attachEvent !== undefined) {
  window.attachEvent('onresize', function () {
    resize()
  })
} else if (window.addEventListener !== undefined) {
  window.addEventListener('resize', function () {
    resize()
  }, true)
}
